<template>
  <div>
    <!-- <div class="paper-tishi">
      <p>
        提示：<br />本次考试只有一次考试机会，你还有10小题未作答，你确定要现在提交试卷吗？
      </p>
      <div class="paper_tip_btn">
        <a href="Results2.html">确定</a><a>取消</a>
      </div>
    </div> -->
    <div class="ckdj_hd">
      <div class="ckdj_hdc">
        试卷名称：{{ testInfo.examName }}
        <a class="face_header_rg" @click="returnExam()">
          返回
        </a>
        <span>得分：{{ testInfo.examResult.finalScore }}分</span>
      </div>
    </div>
    <div class="paper">
      <div class="ckdj_bd">
        <div
          v-for="et in testInfo.etList"
          :key="et.exerciseTypeId"
          class="paper_center_con"
        >
          <h1 class="paper_left_tit per_alltit">
            {{ et.exerciseTypeName }}(共{{ et.description }})
          </h1>
          <br />
          <span v-for="single in et.testContentList" :key="single.seq">
            <p>
              <span>{{ single.seq }}.</span>
              <span v-html="castContentInfo(single)" />
              <span v-if="single.exerciseContentPicture != ''">
                <br /><br />
                <el-image
                  :src="single.exerciseContentPicture"
                  :preview-src-list="[single.exerciseContentPicture]"
                  title="点击查看大图"
                />
              </span>
            </p>
            <span v-if="single.attList.length > 0">
              <ul class="exam_tmfj">
                <li v-for="(att, index) in single.attList" :key="index">
                  <img
                    v-if="
                      imageExt(att.name) === 'jpg' ||
                        imageExt(att.name) === 'png' ||
                        imageExt(att.name) === 'jpeg'
                    "
                    src="@/assets/images/tu_icon.png"
                  />
                  <img
                    v-else-if="imageExt(att.name) === 'mp3'"
                    src="@/assets/images/mp3_icon.png"
                  />
                  <img
                    v-else-if="imageExt(att.name) === 'mp4'"
                    src="@/assets/images/mp4_icon.png"
                  />
                  <img
                    v-else-if="imageExt(att.name) === 'pdf'"
                    src="@/assets/images/pdf_icon.png"
                  />
                  <img v-else src="@/assets/images/fj_icon.png" />
                  附件{{ index + 1 }}:<a
                    type="primary"
                    :href="att.url"
                    target="_blank"
                    ><font color="blue">{{ att.name }}</font></a
                  >
                </li>
              </ul>
            </span>
            <div class="paper_sl">
              <el-radio-group
                v-if="single.originalId === 1 || single.originalId === 3"
                v-model="single.userAnswer"
              >
                <el-radio
                  v-for="opt in single.option"
                  :key="opt.name"
                  :label="opt.id"
                  >{{ opt.id }}.{{ opt.name }}
                </el-radio>
              </el-radio-group>
              <el-checkbox-group
                v-if="single.originalId === 2"
                v-model="single.userAnswer"
              >
                <el-checkbox
                  v-for="opt in single.option"
                  :key="opt.id"
                  :label="opt.id"
                  >{{ opt.id }}.{{ opt.name }}</el-checkbox
                >
              </el-checkbox-group>
              <!-- <div v-if="single.originalId === 4" class="czt_bd">
                <div class="czt">
                  <h1 class="czt_tit per_alltit">作答：</h1>
                  <input type="text" class="tk_bx" placeholder="输入填空一的答案">
                  <input type="text" class="tk_bx" placeholder="输入填空二的答案">
                </div>
              </div> -->
              <el-input
                v-if="single.originalId === 5"
                v-model="single.userAnswer"
                type="textarea"
                :rows="5"
                placeholder="请输入答案"
              />
              <div v-if="single.originalId === 6" class="czt_bd">
                <div class="czt">
                  <h1 class="czt_tit per_alltit">
                    拍照图片列表
                  </h1>
                  <hr color="black" />
                  <!-- <div class="zp_con"> -->
                  <!-- <el-upload
                    name="logo2"
                    class="upload-demo"
                    multiple
                    :limit="20"
                    list-type="picture"
                    :file-list="single.ansList"
                  >
                  </el-upload> -->
                  <!-- <el-image
                    v-for="ans in single.ansList"
                    :key="ans.url"
                    :src="ans.url"
                    style="padding-right:8px;width:132px;height:100%;padding-top:2px;"
                    :preview-src-list="[ans.url]"
                  ></el-image> -->
                  <div class="zp_con">
                    <p>
                      <span v-for="tag in single.ansList" :key="tag.name">
                        <el-image :src="tag.url" />
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div v-if="single.originalId === 7" class="czt">
                <div class="czt">
                  <h1 class="czt_tit per_alltit">上传附件列表</h1>
                  <hr color="black" />
                  <!-- <div class="scfj_btn">
                    <a style="background:#CCC; color:#000">上传附件</a>
                  </div> -->
                </div>
              </div>
              <div v-if="single.originalId === 7">
                <div class="fj_bd">
                  <ul class="exam_tmfj">
                    <li v-for="att in single.ansList" :key="att.url">
                      <img
                        v-if="
                          imageExt(att.name) === 'jpg' ||
                            imageExt(att.name) === 'png' ||
                            imageExt(att.name) === 'jpeg'
                        "
                        src="@/assets/images/tu_icon.png"
                      />
                      <img
                        v-else-if="imageExt(att.name) === 'mp3'"
                        src="@/assets/images/mp3_icon.png"
                      />
                      <img
                        v-else-if="imageExt(att.name) === 'mp4'"
                        src="@/assets/images/mp4_icon.png"
                      />
                      <img
                        v-else-if="imageExt(att.name) === 'pdf'"
                        src="@/assets/images/pdf_icon.png"
                      />
                      <img v-else src="@/assets/images/fj_icon.png" />
                      <a type="primary" :href="att.url" target="_blank"
                        ><font color="blue">{{ att.name }}</font></a
                      >
                      <!-- <span
                        ><img
                          src="@/assets/images/close_icon.png"
                          @click="removeTest(att)"
                      /></span> -->
                    </li>
                  </ul>
                </div>
              </div>
              <div class="jx_bd">
                <h2 class="jx_tit">答案解析</h2>
                <div class="jx_con">
                  <p class="jx_co">
                    <strong>得分：</strong>{{ single.score }}分
                  </p>
                  <!-- <p class="jx_co">
                    <strong>你的答案：</strong>{{ single.userAnswer }}
                  </p> -->
                  <p v-if="single.originalId === 2" class="jx_co">
                    <strong>你的答案：</strong>
                    <span v-for="ua in single.userAnswer" :key="ua.index">
                      {{ ua }}
                    </span>
                  </p>
                  <p v-if="single.originalId !== 2" class="jx_co">
                    <strong>你的答案：</strong>
                    {{ single.userAnswer }}
                  </p>
                  <p class="jx_co">
                    <strong>标准答案：</strong>{{ single.rightAnswer }}
                  </p>
                  <p><strong>解析：</strong>{{ single.answerAnalysis }}</p>
                </div>
                <div>
                  <el-image
                    v-if="single.exerciseAnswerPicture != ''"
                    :src="single.exerciseAnswerPicture"
                    :preview-src-list="[single.exerciseAnswerPicture]"
                    title="点击查看大图"
                  />
                </div>
              </div>
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { lookTest } from "@/api/login";

export default {
  name: "LookExam",
  data() {
    return {
      testInfo: {},
      contentInfo: {},
      etName: "",
      ansList: [],
      examTime: "",
      resultBean: {
        token: "",
        examResultId: ""
      }
    };
  },
  created() {
    this.resultBean.examResultId = this.$route.query.examResultId;
    // this.resultBean.token = this.getToken();
    this.initData();
  },
  methods: {
    initData() {
      lookTest(this.resultBean).then(res => {
        if (res.code === 200) {
          this.testInfo = res.data;
          console.log(this.testInfo);
          this.examTime = this.testInfo.examResult.examTime;
        } else if (res.code === 8003) {
          this.$router.push("/login");
          return;
        }
      });
    },
    castContentInfo(single) {
      if (single.originalId === 4) {
        const phoneReg = /\{\{[0-9]{1}\}\}/;
        if (phoneReg.test(single.exerciseContent)) {
          let contentMsg = "";
          if (single.userAnswer !== "") {
            const tkt = JSON.parse(single.userAnswer);
            contentMsg = single.exerciseContent;
            var reg = new RegExp(phoneReg, "");
            if (tkt !== [] && tkt !== null) {
              for (var i = 0; i < tkt.length; i++) {
                let s = `<input class="answertkt" type="text" value="${tkt[i]}" />`;
                contentMsg = contentMsg.replace(reg, s);
              }
              return contentMsg;
            }
          } else {
            reg = new RegExp(phoneReg, "g");
            let s = `<input class="answertkt" type="text" />`;
            contentMsg = single.exerciseContent.replace(reg, s);
            return contentMsg;
          }
          console.log(contentMsg);
        }
      }
      if (single.originalId === 2) {
        single.userAnswer = single.userAnswer
          .replace(/(.)(?=[^$])/g, "$1,")
          .split(",");
      }
      return single.exerciseContent;
    },
    imageExt(attName) {
      const pos = attName.indexOf(".") + 1;
      const ext = attName.substring(pos, attName.length);
      return ext;
    },
    returnExam() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.el-radio {
  display: block;
  line-height: 40px;
  white-space: normal;
  margin-right: 0;
}
.el-checkbox {
  display: block;
  line-height: 40px;
  white-space: normal;
  margin-right: 0;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}
</style>
